import { IContact } from "@/interfaces/Icontact";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaYoutubeSquare,
} from "react-icons/fa";
import { FiGlobe } from "react-icons/fi";

const SocialLinks = ({ selectedContact }: { selectedContact: IContact }) => {
  const links = selectedContact?.socialLinks;
  if (!links) return null;

  // Helper function to format URLs properly
  const formatUrl = (url: string) => {
    if (!url) return "";

    // If already a full URL, return as is
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }

    // If it looks like a domain without protocol, add https://
    if (url.includes(".") && !url.includes("://")) {
      return `https://${url}`;
    }

    // For other cases, assume it's a path and make it absolute
    return url.startsWith("/") ? url : `/${url}`;
  };

  return (
    <div className="flex space-x-3">
      {links.website && (
        <a
          href={formatUrl(links.website)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiGlobe className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
      {links.facebook && (
        <a
          href={formatUrl(links.facebook)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookSquare className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
      {links.twitter && (
        <a
          href={formatUrl(links.twitter)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitterSquare className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
      {links.linkedin && (
        <a
          href={formatUrl(links.linkedin)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
      {links.instagram && (
        <a
          href={formatUrl(links.instagram)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagramSquare className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
      {links.youtube && (
        <a
          href={formatUrl(links.youtube)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutubeSquare className="w-5 h-5 text-gray-500 hover:text-blue-600" />
        </a>
      )}
    </div>
  );
};

export default SocialLinks;
